export default "__VITE_ASSET__CDyrDZ16__"